// extracted by mini-css-extract-plugin
export var active = "_3k-7";
export var container = "_3k-0";
export var evenWidth = "_3k-4";
export var large = "_3k-5";
export var outlet = "_3k-8";
export var slide = "_3k-2";
export var small = "_3k-6";
export var tab = "_3k-3";
export var tabs = "_3k-1";